import { useTranslate } from 'react-admin';
import Dashboard from '@/components/common/dashboard/dashboard';
import { Avatar } from '@/utils/types';

interface Props {
    params: any;
    clientOrSite: 'client' | 'site' | 'place';
    avatar: Avatar;
}

const InterventionsRequestedDashboard = ({ params, clientOrSite, avatar }: Props) => {
    const translate = useTranslate();

    return (
        <Dashboard
            title={translate('site.dashboards.interventions_requested')}
            leftLabel={translate('site.dashboards.carried_out')}
            rightLabel={translate('site.dashboards.requested')}
            params={params}
            interType={'under_quote'}
            clientOrSite={clientOrSite}
            avatar={avatar}
        />
    );
};

export default InterventionsRequestedDashboard;
